import axios from 'axios';
import store from '../..';
import * as actionTypes from './customersActionTypes';

const isTimeFormat = str => {
    return /^([01]?\d|2[0-3]):[0-5]\d$/.test(str);
}

const buildUrl = (resource, endpoint) => endpoint ? `/api/${resource}/${endpoint}` : `/api/${resource}`;

const axiosConfig = () => ({
    headers: {
        'Authorization': 'Bearer ' + store.getState().auth.userToken
    }
});

export const getCustomersList = (resource, endpoint) => dispatch => {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_LIST_LOADING) });
    axios.get(buildUrl(resource, endpoint),
        axiosConfig())
        .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_LIST), data: responce }))
        .catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_LIST_ERROR) });
        })
};

export const resetError = resource =>
    ({ type: actionTypes.getActionType(resource, actionTypes.RESET_ERROR) });


export const getCustomerPrice = (resource, customerId) => dispatch => {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST_LOADING) });
    const filterData  = {
        params: {
            customerId: customerId,
        },
        headers: axiosConfig().headers,
    };
    axios.get(buildUrl(resource, 'priceTemplates'), filterData,
        axiosConfig())
        .then(response => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST), data: response }))
        .catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST_ERROR) });
        })
};

export const addEmptyLineOnPriceList = (resource, customerId) => ({
    type: actionTypes.getActionType(resource, actionTypes.ADD_EMPTY_LINE_ON_PRICE_LIST), data: customerId
});

export const removeEmptyLinesOnPriceList = (resource) => ({
    type: actionTypes.getActionType(resource, actionTypes.REMOVE_EMPTY_LINES_ON_PRICE_LIST), data: {}
});

export const setItemDisplayState = (resource, rowState, header, enable) => ({
    type: actionTypes.getActionType(resource, actionTypes.SET_DISPLAY_STATE), data: {
        rowState,
        header,
        enable
    }
});

export const setItemData = (resource, value, rowState, header, priceTemplateType, customerId) => dispatch => {
    dispatch({
        type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_DATA), data: {
            value,
            rowState,
            header
        }
    });

    if (rowState.id !== 0) {        
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_DATA_LOADING) });
        axios.put(buildUrl(priceTemplateType, 'updatepricetemplate'), rowState.data, axiosConfig())
        .then(response => {
            if (response.data.hasError || response.hasError) {
                dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_DATA_ERROR), data: response.data.message || response.message });
                console.error(response.data.message || response.message)
                dispatch(reloadPriceListAfterUpdate(priceTemplateType, customerId))
            }
            if (!response.data.hasError && header.key === 'note') {
                dispatch({ type: actionTypes.getActionType(resource, actionTypes.CUSTOMER_PRICE_NOTE_UPDATED)});
            }
        })
        .catch(err => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_DATA_ERROR) });
        });
    }
};

export const addCustomerPrice = (resource, customersPriceList, priceTemplateType, customerId) => dispatch => {
    const requestData = customersPriceList[0].rowState.data;
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.ADD_CUSTOMER_PRICE_LOADING) });
    axios.post(buildUrl(priceTemplateType, 'createpricetemplate'), requestData, axiosConfig())
    .then(response => {
        if (response.data.hasError) {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.ADD_CUSTOMER_PRICE_ERROR), data: response.data.message });
            console.error(response.data.message)
            dispatch(reloadPriceListAfterUpdate(priceTemplateType, customerId))
        } else {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.ADD_CUSTOMER_PRICE), data: response })
        }
    }).catch(err => {
        console.error(err);
        console.log(err.response);
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.ADD_CUSTOMER_PRICE_ERROR) });
    });
};

export const deleteCustomerPrice = (resource, priceType, id, customerId) => dispatch => {
    const filterData  = {
        params: { id: id },
        headers: axiosConfig().headers,
    };    
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.DELETE_CUSTOMER_PRICE_LOADING) });
    axios.delete(buildUrl('pricePerPall', 'deletepricetemplate'), filterData, axiosConfig())
    .then(response => {
        if (response.data.hasError) {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.DELETE_CUSTOMER_PRICE_ERROR) });
            console.error(response.data.message);
        }
        dispatch(reloadPriceListAfterUpdate(priceType, customerId))
    }).catch(err => {
        console.error(err);
        console.log(err.response);
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.DELETE_CUSTOMER_PRICE_ERROR) });
    });
};

export const setCustomerPriceType = (resource, endpoint, customerId, type) => dispatch => {
    const filterData = { 
        customerId: customerId,
        type: type,
    };
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_TYPE_LOADING) });
    axios.put(buildUrl(resource, endpoint), filterData, axiosConfig())
    .then(response => {
        if (response.data.hasError) {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_TYPE_ERROR) });
            console.error(response.data.message);
        }
        dispatch(reloadAfterUpdate(resource, customerId))
    }).catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_TYPE_ERROR) });
        })
};

export const updateCustomerPrice = (resource, data, priceTemplateType, checkedList, customerId) => dispatch => {
    let formulaFieldsByType = [];
    if (priceTemplateType === 'PricePerRange') {
        formulaFieldsByType = [
            {
                "key": '1',
                "value": String(data['1']) ? data['1'] : data['1'] || data['1'] === 0 ? 0 : null,
            },
            {
                "key": '2',
                "value": String(data['2-4']) ? data['2-4'] : data['2-4'] || data['2-4'] === 0  ? 0 : null,
            },
            {
                "key": '3',
                "value": String(data['5-8']) ? data['5-8'] : data['5-8'] || data['5-8'] === 0  ? 0 : null,
            },
            {
                "key": '4',
                "value": String(data['9-12']) ? data['9-12'] : data['9-12'] || data['9-12'] === 0  ? 0 : null,
            },
            {
                "key": '5',
                "value": String(data['13-16']) ? data['13-16'] : data['13-16'] || data['13-16'] === 0  ? 0 : null,
            },
            {
                "key": '6', 
                "value": String(data['17-20']) ? data['17-20'] : data['17-20'] || data['17-20'] === 0  ? 0 : null,
            }
        ]
    } else if (priceTemplateType === 'PricePerPall') {
        const numbers20 = Array.from({ length: 20 }, (_, i) => i + 1);
        formulaFieldsByType = numbers20.map(num => (
            {
                "key": String(num),
                "value": String(data[num]) ? data[num] : data[num] || data[num] === 0 ? 0 : null,
            }
        ))
    };

    const filterData = {
        'ids': checkedList,
        'customerId': customerId,
        'minPrice': Number(data.minPrice) ? data.minPrice : data.minPrice === 0 || data.minPrice ? 0 : null,
        'perWeight': Number(data.perWeight) ? data.perWeight : data.perWeight === 0 || data.perWeight ? 0 : null,
        'formulaFields': formulaFieldsByType,
        'maxPrice': Number(data.maxPrice) ? data.maxPrice : data.maxPrice === 0 || data.maxPrice ? 0 : null,
        'pickAppointmentTime': isTimeFormat(data.pickAppt) ? data.pickAppt : data.pickAppt ? 0 : null,
        'dropAppointmentTime': isTimeFormat(data.dropAppt) ? data.dropAppt : data.dropAppt ? 0 : null,
    }
    
    const formulaFields = filterData.formulaFields?.filter(field => (field.value || field.value === 0) && typeof field.value === "number");
    const finalData = {
        ...filterData,
        formulaFields: formulaFields
    };

    dispatch({ type: actionTypes.getActionType(resource, actionTypes.EDIT_PRICE_TEMPLATE_LOADING) });
    axios.put(buildUrl('PricePerPall/Updatepricetemplatefieldvalue'), finalData, axiosConfig())
    .then(response => {
        if (response.data.hasError || response.hasError) {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.EDIT_PRICE_TEMPLATE_ERROR), data: response.data.message || response.message });
            console.error(response.data.message);
        } else {
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.EDIT_PRICE_TEMPLATE), data: response.data.message })
        }
        dispatch(reloadPriceListAfterUpdate(priceTemplateType, customerId))
    }).catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.EDIT_PRICE_TEMPLATE_ERROR) });
    })
};

const reloadAfterUpdate = (resource, customerId) => dispatch => {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CUSTOMER_PRICE_TYPE_LOADING) });
    axios.get(buildUrl(resource, customerId),
        axiosConfig()
    )
        .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_LIST), data: responce }))
        .catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_LIST_ERROR) });
        });
};

const reloadPriceListAfterUpdate = (resource, customerId) => dispatch => {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST_LOADING) });
    const filterData  = {
        params: {
            customerId: customerId,
        },
        headers: axiosConfig().headers,
    };
    axios.get(buildUrl(resource, 'priceTemplates'), filterData, axiosConfig())
        .then(response => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST), data: response }))
        .catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMERS_PRICE_LIST_ERROR) });
        });
};

export const setPerPalletType = (resource, perPalletType) => ({
    type: actionTypes.getActionType(resource, actionTypes.SET_PER_PALLET_TYPE), data: perPalletType
});

export const getLocationsList = (resource, id) => dispatch => {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMER_LOCATIONS_LIST_LOADING) });
    axios.get(buildUrl(resource, 'locationlist'),
        axiosConfig())
        .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMER_LOCATIONS_LIST), data: responce }))
        .catch((err) => {
            console.error(err);
            console.log(err.response);
            dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CUSTOMER_LOCATIONS_LIST_ERROR) });
        })
};